<template>
  <div class="comp-main">
    <div class="address-top">
      <span>识别：工作地点，工作地址</span>
      <span class="m-l-10"> (示例：北滘办事处，{{ $constant.company_info.company_address }}) </span>
    </div>
    <div class="address-center">
      <el-input
        type="textarea"
        size="mini"
        resize="none"
        :rows="4"
        placeholder="请粘贴或输入文本，点击“文字识别”自动识别“工作地点”和“工作地址”"
        v-model="addressValue"
      />
    </div>
    <div class="address-bottom">
      <el-button class="read-img-box" type="default" size="mini" icon="el-icon-camera-solid">
        图片识别
        <e-upload-image
          class="read-img-upload"
          :list.sync="imgList"
          :limit="1"
          isReadImg
          @success="readImg"
        />
      </el-button>
      <el-button type="primary" size="mini" icon="el-icon-edit-outline" @click="readTxt">
        文字识别
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgList: [],
      addressValue: ''
    }
  },
  methods: {
    readImg(val) {
      this.addressValue = val
      this.readTxt()
    },
    async readTxt() {
      await this.$api({
        method: 'post',
        url: '/admin/gcvip/address/copyOrPaste2',
        data: {
          text: this.addressValue
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = this.$util.deepCopy(res.data.data)
          this.$emit('success', result)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.comp-main {
  display: flex;
  flex-direction: column;
  background: @colorBlue10;
  border: 1px solid @colorGrayD;
  border-radius: 5px;
  overflow: hidden;
  .address-top {
    padding: 0 5px;
    line-height: 32px;
    color: @colorWhite;
    background: @colorBlue;
  }
  .address-center {
    flex: 1;
    line-height: 32px;
    padding: 5px;
  }
  .address-bottom {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 38px;
    padding: 0 5px;
    .read-img-box {
      position: relative;
      overflow: hidden;
      .read-img-upload {
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
      }
    }
  }
}
</style>
